import { GET_ENC, POST_ENC } from "./common/EncryptedHttp";
import { get, post } from "./common/http";
import { API_ENDPOINTS } from "./Utils/endpoints";

export const GetMasterGroupTypeList = () =>
    GET_ENC(API_ENDPOINTS.ACCOUNT.GET_MASTER_GROUP_LIST_FOR_SELECT, null);

export const GetGroupTypeList = (params: any) =>
    GET_ENC(API_ENDPOINTS.ACCOUNT.GET_LIST_FOR_SELECT + params, null);

export const GetAccountList = (params: any) =>
    GET_ENC(API_ENDPOINTS.ACCOUNT.LIST + "?" + params, null);

export const RecalulateLedgerSummary = (params: any) =>
    GET_ENC(API_ENDPOINTS.ACCOUNT.GET_RECALULATE_LEDGER_SUMMARY + params, null);

export const RecalulateStockSummary = (params: any) =>
    GET_ENC(API_ENDPOINTS.ACCOUNT.GET_RECALULATE_STOCK_SUMMARY + params, null);

export const GetAccountDetail = (params: any) =>
    GET_ENC(API_ENDPOINTS.ACCOUNT.GET_DETAIL + params, null);

export const CreateAccount = (data: any) =>
    POST_ENC(API_ENDPOINTS.ACCOUNT.CREATE, data);

export const UpdateAccount = (data: any) =>
    POST_ENC(API_ENDPOINTS.ACCOUNT.UPDATE, data);

export const DeleteAccount = (data: any) =>
    POST_ENC(API_ENDPOINTS.ACCOUNT.DELETE, data);

export const GetAccountsListForExpense = (params: any) =>
    GET_ENC(API_ENDPOINTS.ACCOUNT.GET_ACCOUNTS_LIST_FOR_EXPENSE + params, null);

export const GetAccountsForExpenseDynamicField = (params: any) =>
    GET_ENC(API_ENDPOINTS.ACCOUNT.GET_ACCOUNTS_FOR_EXPENSE_DYNAMIC_FIELD + params, null);

export const GetAccountsForJournalVoucherDynamicField = (params: any) =>
    GET_ENC(API_ENDPOINTS.ACCOUNT.GET_ACCOUNTS_FOR_JOURNAL_VOUCHER_DYNAMIC_FIELD + params, null);

export const GetMasterAccountList = () =>
    GET_ENC(API_ENDPOINTS.ACCOUNT.GET_MASTER_ACCOUNT_LIST, null);

export const GetMasterLedgerGroupList = () =>
    GET_ENC(API_ENDPOINTS.ACCOUNT.GET_MASTER_LEDGER_GROUP_LIST, null);

export const GetAccountDetailByPerameters = (params: any) =>
    GET_ENC(API_ENDPOINTS.ACCOUNT.GET_ACCOUNT_DETAIL_BY_PERAMETERS + params, null);

export const GetAccountsForSalesReport = (params: any) =>
    GET_ENC(API_ENDPOINTS.ACCOUNT.GET_ACCOUNTS_FOR_SALES_REPORT + params, null);

export const GetLedgerAccountSummary = (params: any) =>
    GET_ENC(API_ENDPOINTS.ACCOUNT.GET_LEDGER_ACCOUNT_SUMMARY + params, null);

export const GetLedgerListByAccountCode = (params: any) =>
    GET_ENC(API_ENDPOINTS.ACCOUNT.GET_LIST_BY_ACCOUNT_CODE + params, null);

export const GetLedgerGroupSummaryDetail = (params: any) =>
    GET_ENC(API_ENDPOINTS.ACCOUNT.GET_LEDGER_GROUP_SUMMARY_DETAIL + params, null);




